<template>

  <div>

    <div v-if="permissions.includes('manage_candidates')">

      <div
        v-if="!selectedJob"
        class="alert alert-warning">
        {{ $t('To add a file, select a job') }}
      </div>

      <div v-if="selectedJob">
        <candidate-attach-upload
          @created="loadData">
          </candidate-attach-upload>
      </div>
      
    </div>

    <creating
      v-if="creating"
      height="50px" />

    <div
      v-if="!creating"
      :class="{'box-loading': loading}">
      
      <div class="card">
        <table
          class="table"
          v-if="attachs.length"
          style="margin: 0">
          <thead>
            <tr>
              <th class="text-truncate">{{ $t('Name') }}</th>
              <th class="text-truncate">{{ $t('Author') }}</th>
              <th class="text-truncate">{{ $t('Created at') }}</th>
              <th class="text-truncate"></th>
            </tr>
          </thead>
          <tbody>
            <candidate-attach-item
              v-for="(attach, index) in attachs"
              :key="index"
              :attach="attach">
              </candidate-attach-item>
          </tbody>
        </table>
      </div>

      <no-results
        v-if="!attachs.length"
        class="my-3">
        {{ $t('There are no items') }}
        </no-results>

    </div>

  </div>

</template>

<script>
import CandidateAttachItem from './CandidateAttachItem'
import CandidateAttachUpload from './CandidateAttachUpload'

export default {
  name: 'CandidateAttach',
  components: {
    CandidateAttachItem,
    CandidateAttachUpload
  },
  data () {
    return {
      creating: true,
      loading: true
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.getPermissions
    },
    candidate () {
      return this.$store.getters.getCandidate
    },
    selectedJob () {
      return this.$store.getters.getCandidateSelectedJob
    },
    onlyThisJob () {
      return this.$store.getters.getCandidateOnlyThisJob
    },
    attachs () {
      return this.$store.getters.getCandidateAttachs
    }
  },
  watch: {
    'selectedJob._id': function (val) {
      this.loadData()
    },
    onlyThisJob: function (val) {
      this.loadData()
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData () {
      this.loading = true

      let params = {
        candidate_id: this.candidate._id,
        sort: '-created_at'
      }

      if (this.onlyThisJob && this.selectedJob) {
        params.job_id = this.selectedJob._id
      }

      this.$store
      .dispatch('selectCandidateAttachs', params)
      .then((response) => {
        this.loading = this.creating = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Candidate/Attach/CandidateAttach.vue